import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";

const gridLocation = 'partyAll';


@observer
export default class PartyList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = loc.i18n`All Parties`;
  static rootPage = true;
  static protectedPage = true;
  static icon = 'user';


  static fetchData(routerParams) {
    console.log("PartyList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });

  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           multiUpdateSecurable={SECURABLE.partyGridUpdate} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/party/page/partyList.tsx